export default function ProfileSummary({ summary }) {
  return (
    <div className="ai-summary-card">
      <h3 className="ai-card-title">📝 AI Profile Summary</h3>

      <div className="ai-summary-content">
        {summary}
      </div>
    </div>
  );
}
